export const registerFormContainer = {
  width: "100vw",
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
};
